
import {InfluxDB} from '@influxdata/influxdb-client';
import {influxdbURL, influxdbToken} from "../../environment"

const influxDB = new InfluxDB({url: influxdbURL, token: influxdbToken})


export default influxDB;

